import React, { useState } from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { EchIconFieldInfo } from '../../../../primitives/IconSVG';
import { colors } from '../../../../core/styles/theme/default';

const StyledLabel = styled.label`
  position: relative;
  display: block;
  align-items: center;
  color: ${colors.grey800};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(20)};
  margin-bottom: ${rem(6)};
`;

const StyledTooltip = styled.div`
  display: inline-block;
  margin-left: ${rem(6)};
`;

const StyledTooltipTrigger = styled.button`
  position: relative;
  top: ${rem(-1)};
  vertical-align: top;
  border: none;
  padding: 0;
  background: none;
`;

const StyledTooltipIcon = styled(EchIconFieldInfo)`
  height: ${rem(20)};
  width: ${rem(20)};
  display: block;
`;

const StyledTooltipContent = styled.div`
  position: absolute;
  left: 0;
  bottom: calc(100% + ${rem(6)});
  width: 100%;
  padding: ${rem(12)};
  background: ${colors.white};
  border: ${rem(1)} solid ${colors.purple800};
  border-radius: ${rem(2)};
  font-size: ${rem(12)};
  line-height: ${rem(17)};
  color: ${colors.purple800};
  z-index: 99;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    height: ${rem(8)};
  }

  a {
    text-underline-offset: ${rem(3)};

    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
`;

const Label = ({
  id,
  children,
  tooltip,
  isRequired,
}: {
  id: string;
  children: string;
  tooltip?: string;
  isRequired?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <StyledLabel htmlFor={id}>
      {children}
      {isRequired && '*'}
      {tooltip && (
        <StyledTooltip
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onFocus={() => setIsHovered(true)}
          onBlur={(e) => {
            if (e.relatedTarget?.tagName === 'A') {
              e.preventDefault();
            } else {
              setIsHovered(false);
            }
          }}
        >
          <StyledTooltipTrigger>
            <StyledTooltipIcon />
          </StyledTooltipTrigger>
          {isHovered && (
            <StyledTooltipContent
              dangerouslySetInnerHTML={{ __html: tooltip }}
            />
          )}
        </StyledTooltip>
      )}
    </StyledLabel>
  );
};

export default Label;
